import { useQuery } from "@apollo/react-hooks";
import { GetSubscriptionLimit } from "./queries";

export function useSubscriptionLimit(type) {
  const { loading, data } = useQuery(GetSubscriptionLimit);
  const account = data && data.accounts && data.accounts[0];
  const usageStats = account && account.usageStats;
  const subscriptionPlan =
    account && account.subscription && account.subscription.subscriptionPlan;

  let usage, limit, progress;

  if (usageStats && subscriptionPlan) {
    switch (type) {
      case "videos":
        usage = usageStats.videoCount;
        limit = subscriptionPlan.videoLimit;
        progress = (usage / limit).toFixed(2);
        break;

      case "opportunities":
        usage = usageStats.opportunityCount;
        limit = subscriptionPlan.opportunityLimit;
        progress = (usage / limit).toFixed(2);
        break;

      default:
        throw new Error(`Subscription limit type ${type} not found`);
    }
  }

  const isPartnered =
    subscriptionPlan && subscriptionPlan.nickname.includes("partner");

  const description = isPartnered
    ? "Limits do not apply to Partnered Brands."
    : "Lorem Ipsum is simply dummy text of the printing and type setting industry.";

  return {
    loading,
    usage,
    limit,
    progress,
    description,
    showAlert: usage === limit,
    isPartnered
  };
}
